
import modifyFlowApi from "../../api/modifyFlow";
import modifyFlowAudit from "./components/modifyFlowAudit";
import modifyFlowAdd from "./components/modifyFlowAdd";

export default {
    name: "FlowModify",
    components: {
        modifyFlowAdd,
        modifyFlowAudit
    },
    data() {
        return {
            roleflag:false,
            query:{
                keyword: "",
                state:"1",
                pageIndex: 1,
                pageSize: 10
            },
            flowQuery: {
                keywords: '',
                pageIndex: 1,
                pageSize: 10
            },
            flowPageTotal: 0,
            flowDialogShow: false,
            flowQueryOnce: false,
            chooseFlowId: 0,
            showModifyFlowInfo: false,
            chooseModifyFlowId: 0,
            showAuditModifyFlowInfo: false,
            auditModifyFlowType: 'view',
            flowCols:[
                {
                    "prop": "Id",
                    "label": "流程编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "Name",
                    "label": "申请人",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "BankName",
                    "label": "银行",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "Money",
                    "label": "金额/万元",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "FinalMoney2",
                    "label": "担保部长确认金额/万元",
                    "align": "center"
                },
                {
                    "prop": "UpdateTime",
                    "label": "最后更新时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "100",
                    "align": "center"
                }
            ],
            flowList: [],
            tableCols:[
                {
                    "prop": "ID",
                    "label": "补录编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "Company",
                    "label": "申请者",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "FirstUserName",
                    "label": "发起人",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "Status",
                    "label": "流程状态",
                    "width": "140",
                    "align": "center"
                },
                {
                    "prop": "CurrentNode",
                    "label": "当前节点",
                    "width": "140",
                    "align": "center"
                },
                {
                    "prop": "ModifyContent",
                    "label": "修改内容",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "UpdateTime",
                    "label": "最后更新时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "200",
                    "align": "center"
                }
            ],
            tableData:[],
            scrollHeight:400,
            pageTotal: 0,
            hasAddBtn: false,
            addType:"view"
        }
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize () {
            that.calcTableHeight();
        }
    },
    activated(){
        if(localStorage.getItem("user_info")){
            var routerMap = JSON.parse(localStorage.getItem("routers"))
            for(var i=0;i<routerMap.length;i++){
                var child=routerMap[i].Children;
                for(var j=0;j<child.length;j++){
                    var PermBtns=child[j].PermBtns
                    for(var k=0;k<PermBtns.length;k++){
                        var  mId=Number(PermBtns[k].ButtonValue);
                        if(mId==110||mId==110){
                            this.roleflag=true;
                            this.query= {
                                keyword: "",
                                state:"5",
                                pageIndex: 1,
                                pageSize: 10
                            };
                            break;
                        }
                    }
                   
                }
            }
        }
        this.getModifyFlowList();
    },
    methods: {
        // 补录流程的列表
        getModifyFlowList() {
            let params = this.query
            modifyFlowApi.getModifyFlowList(params).then(res=>{
                this.tableData = res.list
                this.pageTotal = res.count
                this.hasAddBtn = res.hasAddBtn
            })
        },
        // 补录流程的列表翻页
        handleSizeChange(val) {
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getModifyFlowList();
        },
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getModifyFlowList();
        },
        // 选择已完成流程的对话框
        chooseFlowDialog() {
            if (!this.flowQueryOnce) {
                this.getFlowList()
            }
            this.flowDialogShow = true
        },
        // 获取自己已经结束的流程
        getFlowList() {
            this.flowList = []
            let params = this.flowQuery
            modifyFlowApi.getSelfEndedFlowList(params).then(res=>{
                this.flowList = res.list;
                if(this.flowList&&this.flowList.length>0){
                    for(let i=0;i<this.flowList.length;i++){
                        if(this.flowList[i].FinalMoney&&this.flowList[i].FinalMoney!==0){
                            this.flowList[i].FinalMoney2 = this.flowList[i].FinalMoney*1.0/1000000
                        }
                    }
                }
                this.flowPageTotal = res.count
                this.flowQueryOnce = true
            })
        },
        chooseFlow(flowId) {
            let that = this
            this.$confirm('是否要发起流程编号为"'+flowId+'"的数据补录流程, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    modifyFlowApi.canModifyFlowByFlowId({flowId:flowId}).then(res=>{
                       if(res) {
                           // 为true了之后，那么查询担保经理需要审核的页面
                           that.addType="view";
                           that.flowDialogShow = false
                           that.showModifyFlowInfo = true
                           that.chooseFlowId = flowId
                       } else {
                           this.$message({
                               type: 'error',
                               message: '此条流程正在补录中'
                           });
                       }
                    })
                })
        },
        chooseFlow2(Id) {
            this.addType="change";
            this.chooseFlowId = Id
            this.flowDialogShow = false
            this.showModifyFlowInfo = true
        },
        handleFlowSizeChange(val) {
            this.flowQuery.pageIndex = 1;
            this.flowQuery.pageSize = val;
            this.getFlowList();
        },
        handleFlowPageChange(val) {
            this.flowQuery.pageIndex = val;
            this.getFlowList();
        },
        calcTableHeight(){
            this.$nextTick(() => {
                var height1=$(".content-box .content").height();
                var height2=$(".content-box .content .seach-container").height();
                var height=height1-height2-112
                this.scrollHeight = height;
            });
        },
        modifyFlowInfoClose() {
            this.showModifyFlowInfo = false
        },
        modifyFlowInfoSubmit() {
            this.showModifyFlowInfo = false
            this.handlePageChange(1)
        },
        // 点击操作栏的按钮：“view”，“fxAudit”，“fkAudit”
        auditModifyBtnClick(id, type) {
            this.chooseModifyFlowId = id
            this.auditModifyFlowType = type
            this.showAuditModifyFlowInfo = true
        },
        // 审核的框子回调
        auditModifyFlowInfoClose() {
            this.showAuditModifyFlowInfo = false
        },
        auditModifyFlowInfoSubmit() {
            this.showAuditModifyFlowInfo = false
            this.handlePageChange(1)
        }
    }
}
